import { jsx, jsxs } from "react/jsx-runtime";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { Text } from "../../../foundations/typography/Text/Text.js";
import { getPriceVariant } from "./helpers/get-price-variant.js";
import { h as helpers } from "../../../chunks/helpers.module-CuLQagYQ.js";
const styles = {
  "price-type-full": "_price-type-full_1ex7c_1",
  "price-type-new": "_price-type-new_1ex7c_5",
  "price-type-old": "_price-type-old_1ex7c_9"
};
const Price = ({
  children,
  size = "medium",
  variant = "default",
  component = "span",
  "aria-label": ariaLabel,
  type,
  className,
  ...props
}) => {
  const priceVariant = getPriceVariant(size, variant);
  const priceComponent = variant === "strikethrough" ? "s" : component;
  return /* @__PURE__ */ jsxs(
    Text,
    {
      variant: priceVariant,
      component: priceComponent,
      className: clsx(type && styles["price-type-" + type], className),
      ...props,
      children: [
        ariaLabel && /* @__PURE__ */ jsx("span", { className: helpers.srOnly, children: ariaLabel }),
        children
      ]
    }
  );
};
const PriceFull = ({ size, children, ...props }) => /* @__PURE__ */ jsx(Price, { size, type: "full", ...props, children });
const PriceNew = ({ size, children, ...props }) => /* @__PURE__ */ jsx(Price, { size, type: "new", ...props, children });
const PriceOld = ({ size, children, ...props }) => /* @__PURE__ */ jsx(Price, { size, type: "old", variant: "strikethrough", ...props, children });
export {
  Price,
  PriceFull,
  PriceNew,
  PriceOld
};
